module.exports = __webpack_public_path__ + "media/images-example/jardin_bv-d6c6c329.jpeg";